import { useState } from "react";
import { Grid, Header, Segment, Tab } from "semantic-ui-react";
import Users from "./Users";
import Voip from "./Voip";

const AdminSettings = ({ onGenerateAccount }) => {
    const [activeTab, setActiveTab] = useState(0)
    const panes = [
        {
            menuItem: 'Account',
            render: () => (
              <Segment basic>
                <Users onGenerateAccount={onGenerateAccount} />
              </Segment>
            )
        },
        {
            menuItem: 'Post Samples',
            render: () => <Segment basic></Segment>
        },
        {
            menuItem: 'VOIP',
            render: () => <Segment basic><Voip /></Segment>
        }
    ];

    const onChangeActiveTab = (index) => {
        setActiveTab(index);
    }
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Header color='primary'>DYL Admin Settings</Header>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Tab panes={panes} activeIndex={activeTab} onTabChange={(_, { activeIndex }) => { onChangeActiveTab(activeIndex); }}  menu={{ secondary: true, pointing: true, color: 'primary' }} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default AdminSettings;
